<template>
  <transition name="modal">
    <div class="modal-window">
      <div class="panelouter">
        <div class="panel">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'modal-window'
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";

.modal-window {
  background: rgba(0, 0, 0, .8);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  transition: all .5s ease;
  >.panelouter {
    position: absolute;
    left: 0;
    top: 30%;
    width: 100%;
    transition: all .3s ease;
    @include mq-down(md){
      top: 15%;
    }
    >.panel {
      background: #fff;
      padding: 40px;
      margin-left: auto;
      margin-right: auto;
      border-radius: 10px;
      width: 92%;
      max-width: 800px;
      @include mq-down(md){
        padding: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/ModalWindow.vue